module.exports = __webpack_public_path__ + "static/media/catreturns.9712a990.jpg";